import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { calendarES } from '../../../../../../theme/functions/calendarES';
import { SelectItem } from 'primeng/primeng';
import { enableChangeResult } from '../../../../../../theme/functions/enableChangeResult.function';

@Component({
  selector: 'app-new-citation-interview',
  templateUrl: './new-citation-interview.component.html',
  styleUrls: ['./new-citation-interview.component.scss']
})
export class NewCitationInterviewComponent implements OnInit {

  @Input() form:FormGroup;
  @Input() allinone: boolean;
  @Input() resultOptionsSelection:SelectItem[];
  @Input() edit:any;
  @Input() employee_position_id:any;
  @Input() editPart: string;
  public do: boolean = true;
  public showFullForm: boolean = true; // Control para mostrar el formulario completo
  public es: any;
  public employeePositionChangeResultInterview: string = "6,35,37,43,44,58,59,62,63,64,65,66,67";
  public editPartDefined: boolean = false;
  
  constructor() { 
    this.es = calendarES();
  }

  ngOnInit() {
    if(this.editPart != "" && this.editPart != undefined && this.editPart == 'interview')
    {
      this.showFullForm = false;
      this.editPartDefined =  true;
    }
    
    

    this.form.addControl('interviewed_by_id', new FormControl(null));
    this.form.addControl('observation_interview', new FormControl(null));
    this.form.addControl('observation_personal_familiar', new FormControl(null));
    this.form.addControl('academic_information', new FormControl(null));
    this.form.addControl('work_experience', new FormControl(null));
    this.form.addControl('observation_final_concept', new FormControl(null));
    this.form.addControl('result_interview', new FormControl(null, Validators.compose(this.editPartDefined ? [Validators.required,Validators.minLength(1)] : [])));
    this.form.addControl('start_interview', new FormControl({ value: null, disabled: true }));
    this.form.addControl('end_interview', new FormControl({ value: null, disabled: true }));
    this.form.addControl('emergency_contact', new FormControl( null, Validators.compose([Validators.minLength(1)]) ));
    this.form.addControl('emergency_contact_number', new FormControl(null, Validators.compose([Validators.pattern("^[0-9]*$")])));
    
    if(this.edit)
    {
      if(this.edit.result_interview)
        enableChangeResult(this.employee_position_id,this.employeePositionChangeResultInterview,this.edit.result_interview,"result_interview",this.form);
      this.form.patchValue({
        interviewed_by_id: this.edit.interviewed_by,
        observation_interview: this.edit.observation_interview,
        observation_personal_familiar: this.edit.observation_personal_familiar,
        academic_information: this.edit.academic_information,
        work_experience: this.edit.work_experience,
        observation_final_concept: this.edit.observation_final_concept,
  
        start_interview: this.edit.start_interview
          ? new Date(this.edit.start_interview)
          : null,
        end_interview: this.edit.end_interview
          ? new Date(this.edit.end_interview)
          : null,
        result_interview: this.resultOptionsSelection.find(
          (option) => option.value == this.edit.result_interview
        ),
  
        emergency_contact: this.edit.emergency_contact,
        emergency_contact_number: this.edit.emergency_contact_number,
      });
      
    }
    this.do = true;
  }

  public changeResult(variable: any, formControlName: string) {
    const value = this.form.controls[formControlName].value;
    variable = value;
  }

  public toggleForm(): void {
    this.showFullForm = !this.showFullForm;
  }

}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/pages/citations/new-citation/new-citation-interview/new-citation-interview.component.ts